import CreditService from "@/services/credit";
import { CREDIT_TYPE_EXTRACT } from "../../../consts/credit";
import * as types from "./mutationTypes";

export default {
  clearExtract({ commit }) {
    commit(types.CLEAR_EXTRACT);
  },
  async getExtract({ dispatch, rootState, state }) {
    const { uuid } = rootState.organization.organization;

    try {
      const queryParams = state.queryParams ? state.queryParams : {};
      const { data } = await CreditService.getExtract(uuid, queryParams);
      dispatch("setExtract", { extract: data.data.statements, total: data.data.total_rows });
      dispatch("setResume", data.data.resumes);
    } catch (error) {
      return;
    }
  },
  setExtract({ state, commit }, { extract, total }) {
    commit(types.SET_EXTRACT, { extract });
    commit(types.SET_QUERY_PARAMS, {
      ...state.queryParams,
      rowsNumber: total
    });
  },
  setQueryParams({ commit }, queryParams) {
    commit(types.SET_QUERY_PARAMS, queryParams);
  },
  setResume({ commit }, resumes) {
    const resume = {
      monitoring: 0,
      secondary: 0,
      extra: 0
    };
    if (resumes && resumes.length) {
      resumes.forEach((credit) => {
        const credits = Number(credit.credits);
        switch (credit.credit_type) {
          case CREDIT_TYPE_EXTRACT.MONITORED:
            resume.monitoring = credits;
            break;
          case CREDIT_TYPE_EXTRACT.SECONDARY:
            resume.secondary = credits;
            break;
          case CREDIT_TYPE_EXTRACT.EXTRA:
            resume.extra = credits;
            break;
        }
      });
    }
    commit(types.SET_RESUME, resume);
  }
};
